import { createActions, createReducer } from 'reduxsauce'

import DetalhesMetasEducacaoOrgaoService from '../../servicos/DetalhesMetasEducacaoOrgaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesMetasEducacaoOrgaoInicio: [],
    buscaDetalhesMetasEducacaoOrgaoSucesso: ['detalhesMetasEducacaoOrgao'],
    buscaDetalhesMetasEducacaoOrgaoErro: ['erro'],
    setDetalhesMetasEducacaoOrgaoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDetalhesMetasEducacaoOrgao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesMetasEducacaoOrgaoInicio())
        let serv = new DetalhesMetasEducacaoOrgaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesMetasEducacaoOrgaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesMetasEducacaoOrgaoErro(error)))
    }
}

const buscaDetalhesMetasEducacaoOrgaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesMetasEducacaoOrgaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesMetasEducacaoOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesMetasEducacaoOrgao, carregando: false }
}

const setDetalhesMetasEducacaoOrgaoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_ORGAO_INICIO]: buscaDetalhesMetasEducacaoOrgaoInicio,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_ORGAO_ERRO]: buscaDetalhesMetasEducacaoOrgaoErro,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_ORGAO_SUCESSO]: buscaDetalhesMetasEducacaoOrgaoSucesso,
    [Types.SET_DETALHES_METAS_EDUCACAO_ORGAO_ESTADO_DT]: setDetalhesMetasEducacaoOrgaoEstadoDT,
})
